"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "var(--smar--ursa-icons--meterFillColor, #ADC6FA)",
  d: "M2.935 13.36c0-3.034 1.178-4.479 3.14-5.494l1.963 2.585-1.686 2.91H2.935Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M17 13.161c0-3.037-1.179-4.483-3.143-5.5l-1.964 2.588 1.687 2.912H17ZM13.857 7.5C10.714 4.807 8.104 6.425 6 7.105l1.964 3.536 3.929-.393 1.964-2.75Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M3.437 12.95h2.446c.042-.242.106-.478.19-.704l-.725-.395a.7.7 0 1 1 .67-1.23l.759.415c.119-.142.247-.275.384-.4L5.82 8.544a6.59 6.59 0 0 0-2.382 4.407ZM6.99 7.775 8.346 9.89a4.004 4.004 0 0 1 3.246.098l1.418-2.213A6.572 6.572 0 0 0 10 7.05a6.572 6.572 0 0 0-3.01.725Zm7.19.768-1.45 2.262c.565.575.96 1.319 1.104 2.145h2.73a6.59 6.59 0 0 0-2.383-4.407Zm-6.135 3.184a2.616 2.616 0 0 1 1.814-.733c1.45 0 2.636 1.195 2.636 2.656a.7.7 0 0 0 .7.7H17.3a.7.7 0 0 0 .7-.7 8 8 0 1 0-16 0 .7.7 0 0 0 .7.7h3.823a.7.7 0 0 0 .7-.7c0-.25.034-.492.1-.722l2.342 1.278a.7.7 0 0 0 .67-1.23l-2.29-1.249Z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=MeterOneIcon20.js.map